// extracted by mini-css-extract-plugin
export default {"container":"chain_container__-epsF"};